import {ConfEnv} from "@/config/config";
import privateRequest from "@/Infra/http/private.request";

const {BASE_URL, WEBSITE_TOKEN} = ConfEnv.CHATWOOT;

let chatwootReady = null;

export const isChatwootConfigured = Boolean(BASE_URL && WEBSITE_TOKEN);

const loadChatwoot = () => {
  if (chatwootReady) return chatwootReady;

  chatwootReady = new Promise((resolve, reject) => {
    // Our own "Chat en vivo" row opens the widget, so hide the SDK's floating bubble.
    window.chatwootSettings = {hideMessageBubble: true, locale: "es", position: "right"};

    const script = document.createElement("script");
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.async = true;
    script.onerror = () => {
      chatwootReady = null;
      script.remove();
      reject(new Error("Failed to load Chatwoot SDK"));
    };
    script.onload = () => {
      // The SDK dispatches "chatwoot:ready" on `window`; listen before run() so it can't be missed.
      window.addEventListener("chatwoot:ready", () => resolve(), {once: true});
      window.chatwootSDK.run({websiteToken: WEBSITE_TOKEN, baseUrl: BASE_URL});
    };
    document.body.appendChild(script);
  });

  return chatwootReady;
};

const getChatwootIdentity = async () => {
  const response = await privateRequest.get(ConfEnv.API_URL.URL_CHATWOOT_IDENTITY);
  const body = response?.data ?? response;
  return body?.data ?? body;
};

// Backend signs the (token-derived) account ID with the inbox HMAC key. Fail closed:
// no identifier_hash -> do not identify the customer.
export const openLiveChat = async () => {
  const [identity] = await Promise.all([getChatwootIdentity(), loadChatwoot()]);
  if (!identity?.identifier || !identity?.identifier_hash) {
    throw new Error("Chatwoot identity unavailable");
  }

  window.$chatwoot.setUser(identity.identifier, {
    name: identity.name,
    email: identity.email,
    identifier_hash: identity.identifier_hash,
  });
  if (identity.custom_attributes) window.$chatwoot.setCustomAttributes(identity.custom_attributes);
  window.$chatwoot.toggle("open");
};

// Drop the previous customer's conversation from this browser (logout / account switch).
export const resetLiveChat = () => {
  window.$chatwoot?.toggle("close");
  window.$chatwoot?.reset();
};
